<!-- Slide for showing a table of inflation examples -->
<template>
	<div
		v-editable="blok"
		class="fluid h-dvh w-full overflow-y-auto"
	>
		<!-- First column is max-content, the rest are minmax(min-content, max-content) -->
		<div
			class="mx-20 mt-15 grid auto-rows-min grid-cols-[max-content] items-center justify-between gap-x-8 divide-y"
		>
			<div class="col-span-5 grid grid-cols-subgrid py-3">
				<div></div>
				<div></div>
				<div class="font-bold uppercase">{{ blok?.pastLabel }}</div>
				<div class="font-bold uppercase">{{ blok?.presentLabel }}</div>
				<div class="font-bold text-red-500 uppercase">
					{{ blok?.increaseLabel }}
				</div>
			</div>
			<SbInflationExample
				v-for="example in blok?.examples"
				:key="example._uid"
				:blok="example"
				class="py-4"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import SbInflationExample from '@/components/blocks/SbInflationExample.vue'
import type { InflationExamplesStoryblok } from '@/sbTypes'
import type { PropType } from 'vue'

const props = defineProps({
	blok: Object as PropType<InflationExamplesStoryblok>,
})
</script>
